// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.linear-progress-bar.MuiBox-root {
  width: 103px !important;
  height: 24px !important;
}
`, "",{"version":3,"sources":["webpack://./src/views/components/base/linearProgressBar/LinearProgressBar.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,uBAAuB;AACzB","sourcesContent":[".linear-progress-bar.MuiBox-root {\n  width: 103px !important;\n  height: 24px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
